import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';

export const WorkerFoodProgramPat = () => {
  return (
    <DynamicContent
      configPath={
        REMOTE_CONFIG_PATHS.MERCHANT_POLICY.SECTIONS.WORKER_FOOD_PROGRAM
      }
      renderAsHtml={true}
    />
  );
};
